import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AppUpdateProvider } from './contexts/AppUpdateContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AppRoutes } from './routes/AppRoutes';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <AppUpdateProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AppUpdateProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
